export const PHONES = {
  financial: { key: 'financial', label: 'Financial Advice', display: '(443) 293-5042', tel: 'tel:4432935042' },
  medicare: { key: 'medicare', label: 'Medicare', display: '(227) 238-1080', tel: 'tel:2272381080' },
};

export const CALENDARS = {
  retirement:
    'https://api.leadconnectorhq.com/widget/bookings/sgrateam-afe33dce-45e1-4ad9-a725-61ac9bce6c6e-242d191f-9c00-4ef4-bec3-646d49e99951-5f377076-506f-4e33-bdd1-d617da296dca',
  medicare: 'https://api.leadconnectorhq.com/widget/bookings/turning65medicarehelp',
};

export const QUESTIONNAIRE_URL = 'https://thefinancialhq.com/zivaefinancial';

export const SOCIALS = {
  facebook: 'https://facebook.com/ZivaeRetirementConsulting',
  instagram: 'https://instagram.com/zivaefinancial',
  tiktok: 'https://www.tiktok.com/@zivaefinancial',
  youtube: 'https://www.youtube.com/@ZivaeFinancial/shorts',
};

export const STATES_SHORT = 'CA, FL, GA, IL, IN, KY, MD, ME, MI, NC, NM, NY, OH, OR, PA, SC, TX, VA, WI';

export const STATES_FULL =
  'California, Florida, Georgia, Illinois, Indiana, Kentucky, Maryland, Maine, Michigan, North Carolina, New Mexico, New York, Ohio, Oregon, Pennsylvania, South Carolina, Texas, Virginia, and Wisconsin';

export const NAV_LINKS = [
  { label: 'Home', to: '/', testid: 'home' },
  { label: 'Medicare', to: '/medicare', testid: 'medicare' },
  { label: 'Insurance', to: '/insurance', testid: 'insurance' },
  { label: 'Retirement Planning', to: '/retirement-planning', testid: 'retirement' },
  { label: 'About', to: '/about', testid: 'about' },
  { label: 'Contact', to: '/contact', testid: 'contact' },
];
